import React, { useEffect, useState } from 'react';
import comanServices from '../../services/ComanServices';

function Profile() {
    const [userData, setUserData] = useState({
        name: '',
        phone: '',
        email: ''
    });
    const [passwordData, setPasswordData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [profilePic, setProfilePic] = useState(null); // New state for profile picture
    const [previewPic, setPreviewPic] = useState('img/profile.svg'); // Default image path
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    // Fetch user profile data
    useEffect(() => {
        comanServices.profile()
            .then(response => {
              console.log(response)
                setUserData({
                    name: response.name,
                    mobileNo: response.mobileNo,
                    email: response.email
                });
                if (response.image) {
                    setPreviewPic(process.env.REACT_APP_URL + response.image); // Set the profile picture if available
                }
            })
            .catch(error => {
                console.log(error);
                setError('Failed to fetch profile data.');
            });
    }, []);

    // Handle user details input change
    const handleUserChange = (e) => {
        const { name, value } = e.target;
        setUserData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    // Handle profile picture change
    const handleProfilePicChange = (e) => {
        const file = e.target.files[0];
        setProfilePic(file); // Save the selected file
        setPreviewPic(URL.createObjectURL(file)); // Preview the image before upload
    };

    // Handle password input change
    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    // Submit updated user details
    const handleUserSubmit = (e) => {
        e.preventDefault();

        // Create a FormData object to send text and file data
        const formData = new FormData();
        formData.append('name', userData.name);
        formData.append('mobileNo', userData.mobileNo);
        formData.append('email', userData.email);
        if (profilePic) {
            formData.append('image', profilePic); // Append the profile picture file if exists
        }

        comanServices.updateProfile(formData)
            .then(response => {
                setMessage('Profile updated successfully.');
                setError(null); // Clear any previous errors
            })
            .catch(error => {
                console.log(error);
                setError('Failed to update profile.');
                setMessage(null); // Clear any previous messages
            });
    };

    // Submit password change with validation
    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        // Validate new and confirm password
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setError('New password and confirm password do not match.');
            return;
        }

        comanServices.changePassword(passwordData)
            .then(response => {
                setMessage('Password changed successfully.');
                setError(null); // Clear any previous errors
                setPasswordData({
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
            })
            .catch(error => {
                console.log(error);
                setError('Failed to change password.');
                setMessage(null); // Clear any previous messages
            });
    };

    return (
        <div className="right_col" role="main">
            <div className="title-box">
                <h2>Profile</h2>
            </div>
            <div className="container-box p-0 profile-container py-0">
                <div className="profile-header">
                    <div className="profile-img-outer">
                        <img src={previewPic} alt="Profile" />
                        <button className="profile-upload-btn">
                            <input type="file" onChange={handleProfilePicChange} />
                            <i className="fa fa-pencil" />
                        </button>
                    </div>
                </div>

                <div className="container-box-inner p-5">
                    <div className="row">
                        {/* User details form */}
                        <div className="col-md-6">
                            <div className="page-details profile-details">
                                <h4>User details</h4>
                                {error && <p className="error-text">{error}</p>}
                                {message && <p className="success-text">{message}</p>}
                                <form onSubmit={handleUserSubmit} encType="multipart/form-data">
                                    <div className="input-field">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={userData.name}
                                            onChange={handleUserChange}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="input-field">
                                        <label>Phone</label>
                                        <input
                                            type="text"
                                            name="mobileNo"
                                            value={userData.mobileNo}
                                            onChange={handleUserChange}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="input-field">
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={userData.email}
                                            onChange={handleUserChange}
                                            className="form-control"
                                        />
                                    </div>
                                    <button className="submit-green-btn">SUBMIT</button>
                                </form>
                            </div>
                        </div>

                        {/* Change password form */}
                        <div className="col-md-6">
                            <div className="page-details profile-details">
                                <h4>Change your password</h4>
                                {error && <p className="error-text">{error}</p>}
                                {message && <p className="success-text">{message}</p>}
                                <form onSubmit={handlePasswordSubmit}>
                                    <div className="input-field">
                                        <label>Old Password</label>
                                        <input
                                            type="password"
                                            name="oldPassword"
                                            value={passwordData.oldPassword}
                                            onChange={handlePasswordChange}
                                            className="form-control"
                                            placeholder="Enter old password"
                                        />
                                    </div>
                                    <div className="input-field">
                                        <label>New Password</label>
                                        <input
                                            type="password"
                                            name="newPassword"
                                            value={passwordData.newPassword}
                                            onChange={handlePasswordChange}
                                            className="form-control"
                                            placeholder="Enter new password"
                                        />
                                    </div>
                                    <div className="input-field">
                                        <label>Confirm Password</label>
                                        <input
                                            type="password"
                                            name="confirmPassword"
                                            value={passwordData.confirmPassword}
                                            onChange={handlePasswordChange}
                                            className="form-control"
                                            placeholder="Confirm new password"
                                        />
                                    </div>
                                    <button className="list-banner-btn submit-green-btn">SAVE CHANGE</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
